import { seq } from 'async';
import { find, reduce, pick, keys } from 'lodash';
import shortid from 'shortid';
import callApi from '../../util/apiCaller';

export const LOAD_SEARCH_FORM = 'LOAD_SEARCH_FORM';
export const UPDATE_CRITERIA = 'UPDATE_CRITERIA';
export const DELETE_CRITERIA = 'DELETE_CRITERIA';
export const ADD_CRITERIA = 'ADD_CRITERIA';
export const LOAD_CRITERIA_FILTER_DETAIL = 'LOAD_CRITERIA_FILTER_DETAIL';
export const SUBMIT_SEARCH = 'SUBMIT_SEARCH';
export const ADD_SAVED_SEARCH = 'ADD_SAVED_SEARCH';
export const UPDATE_SAVED_SEARCH = 'UPDATE_SAVED_SEARCH';
export const DELETE_SAVED_SEARCH = 'DELETE_SAVED_SEARCH';
export const VIEW_SAVED_SEARCH = 'VIEW_SAVED_SEARCH';
export const RESET_DEFAULT_SEARCH = 'RESET_DEFAULT_SEARCH';
export const CHECK_DIRTY = 'CHECK_DIRTY';

const emptyState = {
  filters: [],
  criteria: [],
  objects: {},
  savedSearches: [],
  savedSearch: null,
  defaultQuery: {},
  statsConditions: {}, // stats for filters amount, close date, etc, ... eg: { is_closed: true }
  query: {
    _id: 'ROOT', // root query
    type: 'groupAND',
    values: [],
  },
  id: null,
};

// because saved group doesn't have id, we need id to dd new criateria to nested group
function addIdToGroup(criterion, isRoot = true) {
  if (criterion) {
    if (criterion.type === 'groupAND' || criterion.type === 'groupOR') {
      const id = isRoot ? 'ROOT' : shortid.generate();
      return {
        _id: id,
        ...criterion,
        values: reduce(criterion.values, (items, val) => {
          const newVal = addIdToGroup(val, false);
          if (newVal) {
            items.push(newVal);
          }
          return items;
        }, []),
      };
    }
    if (!criterion._id) {
      criterion._id = shortid.generate();
    }
    return criterion;
  }
  return null;
}




export function initSearchForm(searchType, queryParams, defaultCriteria = {}, loadRecommendedCriteria = false, urlCriteria = null, isDynamic = false, mainFilters = null, simpleMode = false) {
  return (dispatch) => {
    dispatch({
      type: LOAD_SEARCH_FORM, ...emptyState, status: 'loading', errors: null, searchType, isDynamic,
    });
    const p = new Promise((resolve, reject) => {
      seq(
        (callback) => {
          if (simpleMode) {
            callback(null, []);
          } else {
            // lodad al saved searches
            callApi('saved-search', 'GET', { type: searchType })
              .then(
                ({ searches }) => {
                  callback(null, searches);
                },
                (error) => {
                  callback(error);
                },
              );
          }
        },
        (savedSearches, callback) => {
          if (mainFilters) {
            callback(null, savedSearches, mainFilters, {}, {});
          } else {
            // load the filters first
            callApi('search', 'GET', { ...queryParams, type: searchType })
              .then(
                ({ filters, statsConditions, recommendedCriteria }) => {
                  callback(null, savedSearches, filters, statsConditions, recommendedCriteria);
                },
                (error) => {
                  callback(error);
                },
              );
          }
          
        },
        (savedSearches, filters, statsConditions, recommendedCriteria, callback) => {
          const queryReduce = function queryReduce(node, allFilters, isRoot = false) {
            if (node) {
              if (node.type === 'groupAND' || node.type === 'groupOR') {
                return {
                  _id: isRoot ? 'ROOT' : shortid.generate(),
                  ...(pick(node, ['type', 'id', 'results'])),
                  values: reduce(
                    node.values, (items, val) => {
                      const newNode = queryReduce(val, allFilters, false);
                      if (newNode) {
                        items.push(newNode);
                      }
                      return items;
                    },
                    [],
                  ),
                };
              }
              const pn = {};
              if (node.tag) {
                pn.tag = node.tag;
              } else if (node.filter_id) {
                pn._id = node.filter_id;
              } else if (!node.filter_id && node._id) {
                pn._id = node._id;
              }
              const f = keys(pn).length > 0 ? find(allFilters, pn) : null;
              if (f) {
                let newNode = { ...(pick(node, ['type', 'values', 'mappings', 'control_type', '_id', 'results'])), filter_id: f._id };
                if (loadRecommendedCriteria && recommendedCriteria && recommendedCriteria[node.tag]) {
                  newNode = { ...newNode, ...recommendedCriteria[node.tag] };
                }
                return newNode;
              }
              if (isDynamic) {
                let newNode = { ...node };
                if (loadRecommendedCriteria && recommendedCriteria && recommendedCriteria[node.tag]) {
                  newNode = { ...newNode, ...recommendedCriteria[node.tag] };
                }
                return newNode; 
              }
            }
            return null;
          };
          const defaultQuery = queryReduce(defaultCriteria, filters, true);
          const urlQuery = urlCriteria ? queryReduce(urlCriteria, filters, true) : null;
          callback(null, savedSearches, filters, statsConditions, defaultQuery, urlQuery);
        },
        (savedSearches, filters, statsConditions, defaultQuery, urlQuery, callback) => {
          /*
          use default query or first saved search
          */
          let postParams = urlQuery || defaultQuery;
          let savedSearch = null;
          if (urlQuery === null) {
            savedSearch = find(savedSearches, { active: true });
            if (savedSearch) {
              postParams = addIdToGroup(savedSearch.criteria);
            }
          }
          callback(null, savedSearch, savedSearches, filters, statsConditions, postParams, defaultQuery);
        },
        (savedSearch, savedSearches, filters, statsConditions, postParams, defaultQuery, callback) => {
          const url = 'search/?include=objects';
          callApi(url, 'POST', { ...statsConditions, query: postParams })
            .then(
              ({
                id, objects, query, minDate, maxDate, dynamicFilters,
              }) => {
                callback(null, {
                  savedSearch, savedSearches, filters, dynamicFilters, statsConditions, id, objects, query: query || {}, defaultQuery, minDate, maxDate,
                });
              },
              (error) => {
                callback(error);
              },
            );
        },
      )((error, results) => {
        if (error) {
          reject(error);
        } else {
          resolve(results);
        }
      });
    });
    p.then(
      results => dispatch({
        type: LOAD_SEARCH_FORM, ...results, status: 'loaded', errors: {}, searchType, isDynamic,
      }),
      errors => dispatch({
        type: LOAD_SEARCH_FORM, ...emptyState, status: 'error', errors: errors.data || errors, searchType, isDynamic,
      }),
    );
    return p;
  };
}


export function initSimpleSearchForm(filters, searchType, queryParams, defaultCriteria = {}, isDynamic = false) {
  const simpleMode = true;
  const urlCriteria = null;
  const loadRecommendedCriteria = false;
  return initSearchForm(searchType, queryParams, defaultCriteria, loadRecommendedCriteria, urlCriteria, isDynamic, filters, simpleMode);
}

export function submitSearch(searchType, queryParams = {}, postParams) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      seq((callback) => {
        // load the filters first
        callApi('search', 'POST', { ...queryParams, query: postParams })
          .then(
            ({
              id, query, minDate, maxDate,
            }) => {
              callback(null, {
                id, query, minDate, maxDate,
              });
            },
            (error) => {
              callback(error);
            },
          );
      })((error, results) => {
        if (error) {
          reject(error);
        } else {
          resolve(results);
        }
      });
    });
    p.then(
      results => dispatch({ type: SUBMIT_SEARCH, ...results, searchType }),
      () => {
      },
    );
    return p;
  };
}

export function checkDirty(searchType, debug = false) {
  return dispatch => dispatch({ type: CHECK_DIRTY, searchType, debug });
}

export function updateCriteria(searchType, ids, params = {}) {
  return dispatch => dispatch({
    type: UPDATE_CRITERIA, searchType, ids, params,
  });
}

export function deleteCriteria(searchType, ids) {
  return dispatch => dispatch({ type: DELETE_CRITERIA, ids, searchType });
}

export function addCriteria(searchType, filterId, params = {}, parentQuery, filterInfo = null) {
  return (dispatch) => {
    const id = shortid.generate();
    if (filterId) {
      return dispatch({
        type: ADD_CRITERIA, id, filterId, parentQuery, params, searchType, filterInfo,
      });
    }
    return dispatch({
      type: ADD_CRITERIA, id, filterId: null, parentQuery, params: { type: 'groupAND', values: [], ...params }, searchType,
    });
  };
}

export function fetchFilterValues(searchType, id, q = null, isDynamic = false) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      const params = {
        q,
        skipCount: true,
      };
      callApi(`filters${isDynamic ? '/dynamics' : ''}/${id}/options`, 'GET', params).then(
        (res) => {
          dispatch({
            type: LOAD_CRITERIA_FILTER_DETAIL, id, ...res, searchType,
          });
          resolve(res.options);
        },
        (error) => {
          reject(error);
        },
      );
    });
    return p;
  };
}


export function doSaveSearch(searchType, params) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      callApi('saved-search', 'POST', params).then(
        ({ search }) => {
          dispatch({ type: ADD_SAVED_SEARCH, search, searchType });
          resolve(search);
        },
        (error) => {
          reject(error);
        },
      );
    });
    return p;
  };
}

export function updateSaveSearch(searchType, id, params) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      callApi(`saved-search/${id}`, 'PUT', params).then(
        ({ search }) => {
          dispatch({ type: UPDATE_SAVED_SEARCH, search, searchType });
          resolve(search);
        },
        (error) => {
          reject(error);
        },
      );
    });
    return p;
  };
}

export function deleteSaveSearch(searchType, id) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      callApi(`saved-search/${id}`, 'DELETE').then(
        () => {
          dispatch({ type: DELETE_SAVED_SEARCH, id, searchType });
          resolve(id);
        },
        (error) => {
          reject(error);
        },
      );
    });
    return p;
  };
}


export function loadSaveSearch(searchType, id) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      callApi(`saved-search/load/${id}`, 'GET').then(
        ({ search, objects }) => {
          search.criteria = addIdToGroup(search.criteria);
          dispatch({
            type: VIEW_SAVED_SEARCH,
            search,
            objects,
            searchType,
          });
          resolve({ search, objects });
        },
        (error) => {
          reject(error);
        },
      );
    });
    return p;
  };
}

export function viewSaveSearch(id) {
  return () => {
    const p = new Promise((resolve, reject) => {
      callApi(`saved-search/${id}`, 'GET').then(
        ({ search, users }) => {
          resolve({ search, users });
        },
        (error) => {
          reject(error);
        },
      );
    });
    return p;
  };
}

export function resetDefault(type) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      callApi(`saved-search/reset/${type}`, 'DELETE').then(
        () => {
          dispatch({ type: RESET_DEFAULT_SEARCH, searchType: type });
          resolve(true);
        },
        (error) => {
          reject(error);
        },
      );
    });
    return p;
  };
}

export function getUsers(q) {
  return () => {
    const p = new Promise((resolve, reject) => {
      callApi(`users/?q=${q}&has-access-to=true&active-only=true`, 'GET').then(
        ({ users: { items } }) => {
          resolve(items);
        },
        (error) => {
          reject(error);
        },
      );
    });
    return p;
  };
}

export function shareSearch(id, ids) {
  return () => {
    const p = new Promise((resolve, reject) => {
      callApi(`saved-search/share/${id}`, 'POST', { user_ids: ids }).then(
        () => {
          resolve(true);
        },
        (error) => {
          reject(error);
        },
      );
    });
    return p;
  };
}


export function searchOpportunity(params) {
  return () => {
    const p = new Promise((resolve, reject) => {
      callApi('opportunities', 'GET', params).then(
        (results) => {
          resolve(results);
        },
        (error) => {
          reject(error);
        },
      );
    });
    return p;
  };
}

export function searchAccounts(params) {
  return () => {
    const p = new Promise((resolve, reject) => {
      callApi('accounts', 'GET', params).then(
        (results) => {
          resolve(results);
        },
        (error) => {
          reject(error);
        },
      );
    });
    return p;
  };
}

export function countOpportunities(params) {
  return () => {
    const p = new Promise((resolve, reject) => {
      callApi('search/count-opportunities', 'POST', params).then(
        (results) => {
          resolve(results);
        },
        (error) => {
          reject(error);
        },
      );
    });
    return p;
  };
}
